import baseConfig from '@/config/base';
import { interfaceURL } from '@/config/index';
import Aegis from '@tencent/aegis-web-sdk';
import { getDoctorInfoStorage } from '@/utils/utils';
import AegisV2 from '@tencent/aegis-web-sdk-v2';
const aegis = new Aegis({
  id: baseConfig.aegisKey, // 项目ID，即上报id
  // uin: '', // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true,
  hostUrl: `${interfaceURL}hospital`,
});

const aegisV2 = new AegisV2({
  id: baseConfig.aegisV2Key, // 接入的 topic，唯一标识
  hostUrl: 'https://edge.log.zhiyan.tencent-cloud.net/v1/aegis/collect',
  plugin: {
    pv: true, // 默认开启pv收集器
    aid: true, // 默认开启aid收集器
    error: true, // 默认开启error收集器
    device: true, // 默认开启device收集器
    close: true, // 默认开启close收集器
    pagePerformance: true, // 默认开启pagePerformance收集器
    webVitals: true, // 默认开启webVitals收集器
    api: true, // 默认关闭api数据收集插件，如需开启，设置为 true
    assetSpeed: false, // 默认关闭资源测速插件，如需开启，设置为 true
  },
  onBeforeSend: logs => logs.filter((log) => {
    // 只保留 api 和 error 类型的日志
    if (log.type !== 'api' && log.type !== 'error') {
      return false;
    }
    // 过滤特定的弹窗拦截错误
    if (log.type === 'error') {
      const errorMessage = log.msg || log.message || '';
      const errorStack = log.stack || '';
      // 检查是否包含特定的弹窗拦截错误信息
      const isPopupBlockError = errorMessage.includes('弹窗拦截') || errorStack.includes('弹窗拦截');
      if (isPopupBlockError) {
        return false;
      }
    }
    return true;
  }),
});
export const reportAegisError = ({ type, error, extra = {} }) => {
  extra = {
    ...extra,
    env: process.env.VUE_APP_ENV,
  };
  // eslint-disable-next-line no-param-reassign
  const reportData = {
    type,
    error,
    ...extra,
    userId: getDoctorInfoStorage().userId,
  };
  aegis.report(JSON.stringify(reportData));
  aegisV2.report(JSON.stringify(reportData));
};
